import React from 'react'
import Navbar from '../components/user/Navbar'
import Banner from '../components/user/Banner'
import Card from '../components/user/Card'
import Banner2 from '../components/user/Banner2'
import Footer from '../components/user/Footer'

function Home() {
  return (
   <>
   
   <Navbar/>
   <Banner/>
  
   <Card  />
   <Banner2/>
   <Footer/>

  
   </>
  )
}

export default Home
